// Version check utility for calendar service
// Add this to your taskpane.ts or create a new file

export const CALENDAR_VERSION = {
    version: "2.0.0-optimized",
    buildDate: new Date().toISOString(),
    features: {
        batchAPI: true,
        rateLimit: true,
        singleTokenAcquisition: true,
        maxBatchSize: 20
    }
};

// Add this function to check version in console
(window as any).checkCalendarVersion = function() {
    console.log("=================================");
    console.log("📊 CALENDAR SERVICE VERSION CHECK");
    console.log("=================================");
    console.log("Version:", CALENDAR_VERSION.version);
    console.log("Build Date:", CALENDAR_VERSION.buildDate);
    console.log("Features Enabled:");
    console.log("  ✅ Batch API:", CALENDAR_VERSION.features.batchAPI);
    console.log("  ✅ Rate Limiting:", CALENDAR_VERSION.features.rateLimit);
    console.log("  ✅ Single Token:", CALENDAR_VERSION.features.singleTokenAcquisition);
    console.log("  ✅ Batch Size:", CALENDAR_VERSION.features.maxBatchSize);
    
    // Check if optimization is actually present
    const hasOptimization = typeof (window as any).executeBatchRequest !== 'undefined' || 
                           document.body.innerHTML.includes('BATCH_SIZE');
    
    if (hasOptimization) {
        console.log("✅ OPTIMIZATION ACTIVE - Version 2.0");
    } else {
        console.log("⚠️ Running old version - rebuild needed");
    }
    
    console.log("=================================");
    return CALENDAR_VERSION;
};

// Auto-log version on load
console.log(`Calendar Service ${CALENDAR_VERSION.version} loaded at ${new Date().toLocaleTimeString()}`);
